<template>
  <div class="home">
    <ImageViewer
        v-bind:sourceImageHref="sourceImageHref"
        v-bind:targetImageHref="targetImageHref" />
  </div>
</template>

<script>
// @ is an alias to /src
import ImageViewer from '@/components/ImageViewer.vue'

export default {
  name: 'Viewer',
  components: {
    ImageViewer
  },
  props: {
    sourceImageHref: {type: String},
    targetImageHref: {type: String}
  }
}
</script>
